import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { SiGoogle } from "react-icons/si";
import logoImage from "@/assets/logo.png";
import heroImage from "@assets/generated_images/padel_match_action_shot.png";

export function NativeWelcomeHero() {
  const [, setLocation] = useLocation();

  const handleGoogleLogin = () => {
    window.location.href = "/api/login/player";
  };

  return (
    <div
      className="relative min-h-screen w-full flex flex-col overflow-y-auto bg-black"
      style={{
        paddingTop: "env(safe-area-inset-top, 0px)",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        paddingLeft: "env(safe-area-inset-left, 0px)",
        paddingRight: "env(safe-area-inset-right, 0px)",
      }}
      data-testid="native-welcome-hero"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/90" />

      <div className="relative z-10 flex flex-col flex-1 px-6 py-8">
        <div className="flex items-center gap-2 pt-2">
          <img
            src={logoImage}
            alt="CourtVibe"
            className="h-9 w-9 rounded-full"
            data-testid="img-welcome-logo"
          />
          <span className="font-bold text-lg tracking-tight text-white">
            CourtVibe
          </span>
        </div>

        <div className="flex-1 flex flex-col justify-end gap-6 pt-10">
          <div className="space-y-3">
            <h1
              className="text-4xl font-bold text-white tracking-tight leading-tight"
              data-testid="text-welcome-title"
            >
              Tu padel,
              <span className="block text-primary">en una sola app.</span>
            </h1>
            <p
              className="text-base text-white/80 max-w-md"
              data-testid="text-welcome-tagline"
            >
              Sigue tu nivel, organiza partidos con tus amigos y compite en
              ligas privadas.
            </p>
          </div>

          <div className="flex flex-col gap-3 pt-2">
            <Button
              size="lg"
              onClick={handleGoogleLogin}
              className="bg-white text-black hover:bg-white/90 w-full"
              data-testid="button-welcome-google"
            >
              <SiGoogle className="h-4 w-4 mr-2" />
              Continuar con Google
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLocation("/como-funciona")}
              className="text-white/80 hover:text-white hover:bg-white/10 w-full"
              data-testid="button-welcome-how-it-works"
            >
              Cómo funciona
            </Button>
            <p className="text-xs text-white/60 text-center pt-2">
              Al continuar aceptas nuestros{" "}
              <button
                type="button"
                onClick={() => setLocation("/terminos")}
                className="underline text-white/80 hover:text-white"
                data-testid="link-welcome-terms"
              >
                Términos
              </button>{" "}
              y{" "}
              <button
                type="button"
                onClick={() => setLocation("/privacidad")}
                className="underline text-white/80 hover:text-white"
                data-testid="link-welcome-privacy"
              >
                Privacidad
              </button>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
